import PropTypes from "prop-types";
import MDBox from "theme/components/MDBox";

import { usePlacesWidget } from "react-google-autocomplete";
import { TextField } from "@mui/material";

function GoogleAddressField({ displayName, setAddress, setLatitude, setLongitude }) {
  const { ref } = usePlacesWidget({
    apiKey: "AIzaSyCmiv_wy1kjzBT6tcvMK56pdhfpG32Ljw0",
    onPlaceSelected: (place) => {
      // console.log(place);
      setAddress(place.formatted_address);
      setLatitude(place.geometry.location.lat());
      setLongitude(place.geometry.location.lng());
    },
    options: {
      // types: ["(regions)"],
      types: ["address"],
      // componentRestrictions: { country: "ng" },
    },
  });

  // console.log(options);
  return (
    <MDBox>
      <TextField
        inputRef={ref}
        margin="dense"
        label={displayName}
        type="text"
        fullWidth
        variant="outlined"
        multiline
        minRows={2}
      />
    </MDBox>
  );
}

// Typechecking props of the Transaction
GoogleAddressField.propTypes = {
  displayName: PropTypes.string.isRequired,
  setAddress: PropTypes.func,
  setLatitude: PropTypes.func,
  setLongitude: PropTypes.func,
};

GoogleAddressField.defaultProps = {
  setAddress: null,
  setLatitude: null,
  setLongitude: null,
};

export default GoogleAddressField;
